document.documentElement.classList.remove("no-js");

document.addEventListener("DOMContentLoaded", () => {
  const menuToggle = document.querySelector("[data-menu-toggle]");
  const mobileMenu = document.querySelector("[data-mobile-menu]");

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", () => {
      const expanded = menuToggle.getAttribute("aria-expanded") === "true";
      menuToggle.setAttribute("aria-expanded", String(!expanded));
      mobileMenu.hidden = expanded;
      document.body.classList.toggle("panel-open", !expanded);
    });
  }

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    const variantInput = form.querySelector("[data-variant-input]");
    const price = form.querySelector("[data-product-price]");
    const buttonPrice = form.querySelector("[data-button-price]");
    const variantButtons = form.querySelectorAll("[data-variant-button]");

    variantButtons.forEach((button) => {
      button.addEventListener("click", () => {
        variantButtons.forEach((candidate) => {
          candidate.classList.remove("active");
          candidate.setAttribute("aria-pressed", "false");
        });
        button.classList.add("active");
        button.setAttribute("aria-pressed", "true");
        if (variantInput) variantInput.value = button.dataset.variantId;
        if (price) price.textContent = button.dataset.variantPrice;
        if (buttonPrice) buttonPrice.textContent = button.dataset.variantPrice;
      });
    });
  });

  initReviews();
});

async function initReviews() {
  const section = document.querySelector("[data-reviews]");
  if (!section) return;

  const grid = section.querySelector("[data-review-grid]");
  const search = section.querySelector("[data-review-search]");
  const filters = section.querySelector("[data-review-filters]");
  const distribution = section.querySelector("[data-rating-distribution]");
  const results = section.querySelector("[data-review-results]");
  const clear = section.querySelector("[data-review-clear]");
  const more = section.querySelector("[data-reviews-more]");
  const remaining = section.querySelector("[data-reviews-remaining]");
  if (!grid || !filters || !distribution || !results || !more || !remaining) return;

  let reviews = [];
  try {
    const response = await fetch(section.dataset.reviewsUrl);
    if (!response.ok) return;
    reviews = await response.json();
  } catch {
    return;
  }

  const state = { rating: null, query: "", visible: 12 };
  const scores = [5, 4, 3, 2, 1];

  const countFor = (score) => reviews.filter((review) => Number(review.rating) === score).length;
  scores.forEach((score) => {
    const count = countFor(score);
    const row = document.createElement("button");
    row.type = "button";
    row.innerHTML = `<span>${score} star</span><i><b style="width:${reviews.length ? (count / reviews.length) * 100 : 0}%"></b></i><strong>${count}</strong>`;
    row.addEventListener("click", () => setRating(score));
    distribution.appendChild(row);
  });

  const allFilter = createFilter("All", reviews.length, null);
  filters.appendChild(allFilter);
  scores.forEach((score) => filters.appendChild(createFilter(`${score}★`, countFor(score), score)));

  function createFilter(label, count, rating) {
    const button = document.createElement("button");
    button.type = "button";
    button.dataset.rating = rating === null ? "all" : String(rating);
    button.innerHTML = `${label} <span>${count}</span>`;
    button.addEventListener("click", () => setRating(rating));
    return button;
  }

  function setRating(rating) {
    state.rating = rating;
    state.visible = 12;
    render();
  }

  function filtered() {
    const query = state.query.toLowerCase().trim();
    return reviews.filter((review) => {
      if (state.rating && Number(review.rating) !== state.rating) return false;
      if (!query) return true;
      return [review.title, review.body, review.reviewer].some((value) => String(value || "").toLowerCase().includes(query));
    });
  }

  function render() {
    const matches = filtered();
    const shown = matches.slice(0, state.visible);
    grid.replaceChildren(...shown.map(reviewCard));
    results.textContent = `Showing ${shown.length} of ${matches.length}`;
    clear.hidden = state.rating === null;
    more.hidden = shown.length >= matches.length;
    remaining.textContent = `${Math.max(0, matches.length - shown.length)} remaining`;
    filters.querySelectorAll("button").forEach((button) => button.classList.toggle("active", button.dataset.rating === (state.rating === null ? "all" : String(state.rating))));
  }

  function reviewCard(review) {
    const card = document.createElement("article");
    card.className = "review-card";
    const top = document.createElement("div");
    top.className = "review-card-topline";
    const stars = document.createElement("span");
    stars.className = "review-stars";
    stars.textContent = "★".repeat(Number(review.rating)) + "☆".repeat(5 - Number(review.rating));
    const date = document.createElement("time");
    date.dateTime = review.createdAt;
    date.textContent = new Date(review.createdAt).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
    top.append(stars, date);
    const title = document.createElement("h3");
    title.textContent = review.title || "Customer review";
    const body = document.createElement("p");
    body.className = "review-body";
    body.textContent = review.body || "";
    const footer = document.createElement("div");
    footer.className = "review-card-footer";
    const reviewer = document.createElement("strong");
    reviewer.textContent = review.reviewer || "Verified customer";
    const badges = document.createElement("div");
    if (review.verifiedBuyer) badges.appendChild(badge("Verified buyer"));
    if (review.incentivized) badges.appendChild(badge("Incentivized review"));
    footer.append(reviewer, badges);
    card.append(top, title, body, footer);
    return card;
  }

  function badge(text) {
    const badge = document.createElement("span");
    badge.textContent = text;
    return badge;
  }

  search?.addEventListener("input", (event) => {
    state.query = event.target.value;
    state.visible = 12;
    render();
  });
  clear?.addEventListener("click", () => setRating(null));
  more.addEventListener("click", () => {
    state.visible += 12;
    render();
  });
  render();
}
